import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import Notification from 'components/Notification'
import { getAssociatedInstancesNotificationsSelector } from 'modules/notifications/selectors'
import { clickNotificationAction } from 'modules/notifications/actions/click'
import { getContentObjNotificationUtil } from 'models/daos/notification/utils'

class NotificationContainer extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    instance: PropTypes.object,
    associatedInstances: PropTypes.arrayOf(PropTypes.object).isRequired
  }

  shouldComponentUpdate (nextProps) {
    // Don't udpate if the `read` has been updated
    const shouldUpdate = !(
      !this.props.instance.data.read && nextProps.instance.data.read
    )
    return shouldUpdate
  }

  handleClick () {
    this.props.dispatch(
      clickNotificationAction(
        this.props.instance
      )
    )
  }

  render () { // On server-side rendering, associated instances are not in their domain yet
    if (!this.props.associatedInstances.length) {
      return <div />
    }
    const { instance } = this.props
    const contentObj = getContentObjNotificationUtil(
      instance, this.props.associatedInstances
    )
    return (
      <Notification
        isRead={!!instance.data.read}
        onClick={this.handleClick.bind(this)}
      >
        <Notification.Image
          icon={contentObj.icon}
          iconColor={contentObj.iconColor}
          source={contentObj.image}
          url={contentObj.imageUrl}
        />

        <Notification.Text
          bold={contentObj.textBold}
          prefix={contentObj.textPrefix}
          updatedAt={instance.data.updatedAt}
          url={contentObj.textUrl}
          value={contentObj.text}
        />

        {
          contentObj.image2 &&
            <Notification.Image
              source={contentObj.image2}
              url={contentObj.image2Url}
            />
        }
      </Notification>
    )
  }
}

const select = () => createSelector(
  getAssociatedInstancesNotificationsSelector(),
  (associatedInstances) => ({
    associatedInstances
  })
)
export default connect(select)(NotificationContainer)
